__webpack_require__.p = "/mi-assets/mi-static/mi-awp-renderer/web-rel-26.6.1-fec70de-10961/_next/";